var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch"},[_c('label',{staticClass:"switch-label"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.value},on:{"change":_vm.toggleSwitch}}),_c('span',{staticClass:"switch-input"})])])}
var staticRenderFns = []

export { render, staticRenderFns }